import { IndividualStatus } from '@aslanpay/portal-common-lib';

export enum Role {
  SYSTEM_USER = 'System user',
  ASLAN_ADMIN = 'Aslan admin',
  COMPANY_ADMIN = 'Company admin',
  EMPLOYEE = 'Employee',
}

export enum PauseReason {
  MATERNITY_LEAVE = 'Maternity/Paternity leave',
  EXTENDED_SICK_LEAVE = 'Extended sick leave',
  FRAUD = 'Fraud',
  HR_REASONS = 'HR reasons',
  PROBATION = 'Probation',
}

export const Status: Record<IndividualStatus, { color: string; value: string; tooltip: string }> = {
  CREATED: {
    color: 'created',
    value: 'Created',
    tooltip: 'Imported into the database but not invited to sign-up',
  },
  INVITED: {
    color: 'invited',
    value: 'Invited',
    tooltip: 'Invited but has not signed up',
  },
  ACTIVE: {
    color: 'active',
    value: 'Active',
    tooltip: 'Confirmed and using the application',
  },
  DELETED: {
    color: 'deleted',
    value: 'Deleted',
    tooltip: 'Employee was deleted',
  },
  PAUSED: {
    color: 'paused',
    value: 'Paused',
    tooltip: 'Employee access to card is paused',
  },
  LEFT: {
    color: 'left',
    value: 'Left',
    tooltip: 'Employment terminated',
  },
  LEAVING: {
    color: 'leaving',
    value: 'Leaving',
    tooltip: 'Employee is leaving and has access',
  },
  RESTRICTED: {
    color: 'restricted',
    value: 'Restricted',
    tooltip: 'Employee is leaving and access is restricted',
  },
};
